import { create } from "zustand";
import { combine } from "zustand/middleware";
import { SystemConfigurationData } from "@components/forms/system-configuration/types";

const DEFAULT_SYSTEM_CONFIGURATION: SystemConfigurationData = {
  batteryCapacity: 9.5,
};

export const useSystemConfiguration = create(
  combine(DEFAULT_SYSTEM_CONFIGURATION, (set) => ({
    setBatteryCapacity: (
      batteryCapacity: SystemConfigurationData["batteryCapacity"],
    ) => set((state) => ({ ...state, batteryCapacity })),
  })),
);
